/**
 * @ngdoc directive
 * @name donationformpayment
 *
 * @description
 * Donation Form payment
 */
module.directive('donationformpayment', function () {
    'use strict';
    return {
        restrict: 'E',
        controller: ['$scope', function ($scope) {
            var frequencySingle = 'unique';
            var frequencyMonthly = 'mensuel';

            $scope.submitLabel = 'Valider mon don';
            $scope.pendingLabel = 'Veuillez patienter';

            /* list filtering */
            $scope.filterPayment = function (filter) {
                return function (payment) {
                    return payment.frequency === filter;
                };
            };

            /* filter by frequency */
            $scope.isSinglePayment = false;
            $scope.isMonthlyPayment = false;

            // trigger payment options choices
            $scope.$watchCollection('formModel.frequence', function (newValue) {
                if (!newValue) {
                    return;
                }

                $scope.isSinglePayment = newValue === frequencySingle;
                $scope.isMonthlyPayment = newValue === frequencyMonthly;

                if (newValue === frequencySingle) {
                    /* default payment mode */
                    if ($scope.formModel.paymentOptions[0].enabled) {
                        $scope.formModel.option = 0;
                    } else {
                        $scope.formModel.option = 1;
                    }
                }
                if ($scope.isMonthlyPayment) {
                    $scope.formModel.option = 3;
                }
            });

            /* Payment option information display */
            $scope.paymentInfo = '';
            $scope.$watchCollection('formModel.option', function (newValue) {
                if (isNaN(parseInt(newValue))) {
                    $scope.paymentInfo = '';
                } else {
                    $scope.paymentInfo = $scope.formModel.paymentOptions[newValue].text;
                }
            });

            /* active class switcher */
            $scope.isOptionActive = function (index) {
                return index === $scope.formModel.option;
            };
        }],
        template:
                '  <section class="aqua-donationform-payment">' +
                '    <a name="paiement"></a>' +
                '    <div class="grid-main grid grid-center">' +
                '      <h2 class="grid grid-center"><span class="aqua-donationform-payment--title">Mon règlement</span></h2>' +

                '      <ul ng-if="isSinglePayment" class="aqua-donationform-payment--options grid-10 grid-12-m grid-12-s grid grid-between">' +

                '        <li class="aqua-form--radios_deprecated-alternate aqua-donationform-payment--option grid-4 grid-12-s grid grid-center" ng-repeat="option in formModel.paymentOptions | filter:filterPayment(\'unique\')" ng-class="{\'is-disabled\': !option.enabled}" ng-attr-title="{{option.enabled ? \'\' : \'Moyen de paiement temporairement indisponible\'}}">' +
                '          <label class="grid-12-s" ng-class="{\'is-active\': isOptionActive($index)}">' +
                '            <input type="radio" class="aqua-form--radio_deprecated" name="mode" ng-value="{{$index}}" ng-model="formModel.option"  ng-disabled="!option.enabled" /> <span class="{{option.class}}">{{option.label}}</span>' +
                '          </label>' +
                '        </li>' +

                '      </ul>' +

                '      <div class="aqua-donationform-payment--info grid-12">' +
                '        <p class="aqua-donationform-payment--info-text" ng-bind-html="paymentInfo | trustAsHtml"></p>' +
                '      </div>' +

                '      <button ng-class="{\'is-pending\': formModel.pending}" type="submit" class="aqua-donationform-payment--button">{{formModel.pending ? pendingLabel : submitLabel}}</button>' +

                '    </div>' +
                '  </section>'
    };
});